// extracted by mini-css-extract-plugin
export default {"imageWrapper":"lE-z","hovered":"mE-z","hoverImage":"nE-z","mainImage":"oE-z","imageNoBackground":"pE-z","fullSizeImage":"qE-z"};